import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Grid2, Box, Menu, Grow, MenuItem } from "@mui/material";
import LayoutWrapper from "./LayoutWrapper";
import TradingViewChart from "../../components/charts/RealtimeTrdingChart";
import { getAllOrders } from "../../api/request/dashboard/dashboard";
import { getCookies } from "../../services/Cookies";
import SymbolCell from "../../components/tablecells/SymbolCell";
import TabPannel from "../../components/tab/TabPannel";
import TradeModal from "../../components/modal/trading/TradingModal";
import { useDispatch, useSelector } from 'react-redux'
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice'
import { ThemeContext } from "../../context/ThemeContext";
import MenuComponent from '../../components/menu/MenuComponent';
import { setSymbol } from '../../store/Slices/symbolSlice';
import OneClick from "../../components/modal/OneClick";
import ModifyPosition from "../../components/modal/ModifyPosition";
import SearchWithGroupFilter from "../../components/search/SearchDropdown";
import '../../App.scss'
import CheckIcon from "@mui/icons-material/Check"
import WatchlistTable from "../../components/table/WatchlistTable";
// import { useSymbolPrices } from '../../context/WebSocketContext';
import { setGlobalSymbolsData, setGlobalSymbolID, setTradeModalOpen, setModifyPositionOpen, setModifyPositionDetail, setOneClickSymbolDetail } from '../../store/Slices/globalSymbolSlice'
import toast from "react-hot-toast";


const Dashboard = () => {
  const { darkMode } = useContext(ThemeContext)
  const dispatch = useDispatch()
  const showCreateOrder = useSelector((state) => state.menu);
  const [loading, setLoding] = useState(false);
  const [openModal, setOpenModal] = useState(false); //on double click modal open 
  const id = getCookies("clientId");
  const { accountId } = useSelector(state => state.accountSummary)
  const [searchQuery, setSearchQuery] = useState("");
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSymbolPanelVisible, setIsSymbolPanelVisible] = useState(true);
  const [activeRowId, setActiveRowId] = useState(null);
  const [accountHistory, setAccountHistory] = useState([])
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
  const [hiddenSymbols, setHiddenSymbols] = useState(new Set());
  const [visibleColumns, setVisibleColumns] = useState(['name', 'bid', 'ask', 'spread']);
  const [menuPositionTH, setMenuPositionTH] = useState(null);
  const { symbols } = useSelector(state => state.watchlist)
  const { globalSymbol, globalSymbolID, orderPanelOpen, modifyPositionModalOpen, modifyPositionDetail } = useSelector(state => state.globalSymbol)
  const dataRef = useRef(symbols)
  const ref = useRef()
  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsSearchDropdownOpen(query.length > 0);
  };

  // const filteredSymbols = symbolData?.[0] && symbolData.filter(symbol =>
  //   symbol.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  useEffect(() => {
    dataRef.current = symbols;
  }, [symbols]) // This will run whenever selectedSymbol changes

  const handleRowClick = useCallback((symbol) => {
    dispatch(setGlobalSymbolsData(symbol))
    dispatch(setGlobalSymbolID(symbol.id))
    dispatch(setSymbol({ symbolId: symbol.id, symbolName: symbol.name, bid: symbol.bid, ask: symbol.ask }));
  }, [dispatch])

  const handleRowDoubleClick = (symbol) => {
    dispatch(setTradeModalOpen(true));
    dispatch(setModifyPositionOpen(false));
    dispatch(setSymbol({ symbolId: symbol.id, symbolName: symbol.name }));
    const panel = ref.current;
    if (panel) {
      panel.resize(30);
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    dispatch(setTradeModalOpen(false));
    const panel = ref.current;
    if (panel) {
      panel.resize(0);
    }
  };
  const handleResize = (newSize, oldSize) => {
    // if (newSize < 10) {
    //   closeModal();
    // }
  };
  const isTradePanelOpen = showCreateOrder;
  const handleCloseCreateOrderPanel = () => {
    dispatch(handleCloseCreateOrder());
    closeModal();
  };

  const handleRowRightClick = useCallback((event, row) => {
    event.preventDefault();
    setMenuPosition({ top: event.clientY, left: event.clientX });
    // dispatch(setGlobalSymbolID(row.id))
    dispatch(setSymbol({ symbolId: row.id, symbolName: row.name, bid: row.bid, ask: row.ask }));
    setSelectedRow(row);
  }, [dispatch])

  const handleCloseMenu = () => {
    setMenuPosition(null);
    // setSelectedRow(null);
    if (!modalOpen) {
      setSelectedRow(null);
    }
  };

  const handleOpenOneTradeModal = () => {
    dispatch(setTradeModalOpen(true))
    dispatch(setModifyPositionOpen(false))
    if (selectedRow) {
      dispatch(setGlobalSymbolID(selectedRow.id))
    }
    const panel = ref.current;
    if (panel) {
      panel.resize(30);
    }
    handleCloseMenu();
  };

  useEffect(() => {
    console.log("orderPanel", orderPanelOpen)
    if (orderPanelOpen) {
      dispatch(setModifyPositionOpen(false))
    }
  }, [orderPanelOpen]);

  // useEffect(() => {
  //   if (!modifyPositionModalOpen) {
  //     dispatch(setTradeModalOpen(true))
  //   }
  // }, [modifyPositionModalOpen]);

  const handleChartClick = () => {
    if (selectedRow) {
      dispatch(setGlobalSymbolsData(selectedRow))
      dispatch(setGlobalSymbolID(selectedRow.id))
    }
  };

  const openOneClickModal = () => {
    dispatch(setOneClickSymbolDetail(globalSymbol))
    setModalOpen(true);
  };

  const closeOneClickModal = () => {
    setModalOpen(false);
  }

  const toggleSymbolPanel = () => {
    setIsSymbolPanelVisible((prev) => !prev);
  };
  const currentSymbol = useSelector((state) => state.symbol.selectedSymbol.symbolId);
  const currentSymbolIdForModal = currentSymbol || globalSymbolID; // Determine symbolId priority

  const handleOpenModifyPositionModal = (orderDetails) => {
    dispatch(setModifyPositionOpen(true))
    dispatch(setModifyPositionDetail(orderDetails))

    const panel = ref.current;
    if (panel) {
      panel.resize(30); // Resize the panel to 30% width
    }
  };
  const handleCloseModifyPositionModal = () => {
    dispatch(setModifyPositionOpen(false))
    const panel = ref.current;
    if (panel) {
      panel.resize(0); // Close the panel
    }
  };

  const fetchOrders = async () => {
    try {
      const updatedOrders = await getAllOrders(accountId);
      setAccountHistory(updatedOrders?.data);
    } catch (error) {
      console.error("Error fetching updated orders:", error);
    }
  };

  useEffect(() => {
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    setHiddenSymbols(new Set(storedHiddenSymbols));

    const storedColumns = JSON.parse(localStorage.getItem(`visibleColumns_${id}`));
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    }
  }, [id]); // Depend on `id` to load the correct user's data

  const handleHideSymbol = (symbolId) => {
    const updatedHiddenSymbols = new Set(hiddenSymbols);
    if (symbolId !== null) {
      updatedHiddenSymbols.add(Number(symbolId));
    }

    setHiddenSymbols(updatedHiddenSymbols);
    localStorage.setItem(
      `hiddenSymbols_${id}`,
      JSON.stringify(Array.from(updatedHiddenSymbols).filter(Boolean))
    );
  };


  const handleColumnVisibilityToggle = (columnDataIndex) => {
    setVisibleColumns((prev) => {
      const updatedColumns = prev.includes(columnDataIndex)
        ? prev?.filter(col => col !== columnDataIndex)
        : [...prev, columnDataIndex];

      localStorage.setItem(`visibleColumns_${id}`, JSON.stringify(updatedColumns));
      return updatedColumns;
    });
  };

  const handleTableHeaderRightClick = (event) => {
    event.preventDefault();
    const menuPosition = { top: event.clientY, left: event.clientX };
    setMenuPositionTH(menuPosition);
  };
  const symbolCellData = SymbolCell();
  const visibleColumnsData = symbolCellData.filter(col => visibleColumns.includes(col.dataIndex));

  const sortedSymbols = useMemo(() => Object.values(symbols), [symbols]);

  const data = Object.values(symbols).filter(symbol => symbol.isVisible);
  useEffect(() => {
    if (data && data.length > 0) {
      const visibleSymbols = data.filter(symbol => !hiddenSymbols.has(symbol.id));

      if (visibleSymbols.length > 0) {
        const firstSymbol = visibleSymbols[0];
        if (firstSymbol?.id && firstSymbol?.name) {
          dispatch(setGlobalSymbolsData(firstSymbol));
        }
      }
    }
  }, [symbols, hiddenSymbols]);


  const handleChartFromTradeTabClick = (symbol) => {
    dispatch(setGlobalSymbolsData(symbol))

  };

  const handleOpenNewDashboard = (symbolName, symbolId) => {
    dispatch(setSymbol({ symbolId, symbolName }));
    dispatch(setTradeModalOpen(true));

    const queryParams = new URLSearchParams({ symbolName, symbolId }).toString();
    const tradeWindow = window.open(`/watchlist-trade?${queryParams}`, "_blank", "width=400,height=500,top=100,left=100");

    if (!tradeWindow) {
      toast.error("Popup blocked! Please allow popups for this site.");
    }
  };

  const params = new URLSearchParams(window.location.search);
  const symbolId = params.get("symbolId");

  useEffect(() => {
    if (symbolId) {
      setOpenModal(true);
      dispatch(setTradeModalOpen(true))
      dispatch(setGlobalSymbolID(symbolId))
      dispatch(setSymbol({ symbolId }));
    }
  }, [symbolId, dispatch]);

  return (
    <>
      <LayoutWrapper openOneClickModal={openOneClickModal} closeOneClickModal={closeOneClickModal} isSymbolPanelVisible={isSymbolPanelVisible} toggleSymbolPanel={toggleSymbolPanel} handleOpenOneTradeModal={handleOpenOneTradeModal} currentSymbolId={currentSymbolIdForModal} handleOpenNewDashboard={handleOpenNewDashboard}>
        <Grid2 style={{ height: 'calc(100vh - 44px - 30px)' }}>
          <PanelGroup direction="vertical" style={{ height: "100%" }}>
            <Panel id="top-panel" order={1} minSize={35} >
              <PanelGroup direction="horizontal">
                <Panel key={`${modifyPositionModalOpen}-${orderPanelOpen}`} id="trade-panel" order={2} minSize={0} defaultSize={orderPanelOpen ? 20 : modifyPositionModalOpen ? 20 : 0} maxSize={orderPanelOpen ? 20 : modifyPositionModalOpen ? 20 : 0} size={20} style={{ transition: "width 0.5s ease", }} onResize={handleResize} ref={ref}>
                  <Box style={{ height: "100%", width: "100%" }}>
                    {modifyPositionModalOpen && <ModifyPosition onClose={handleCloseModifyPositionModal} onOrderModified={fetchOrders} />}
                    {(orderPanelOpen || openModal) && (<TradeModal open={isTradePanelOpen} onClose={handleCloseCreateOrderPanel} showCloseButton={true} />)}
                  </Box>
                </Panel>

                <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', width: "3px", transition: "background-color 0.2s ease", }} />
                <Panel id="chart-panel" order={3} defaultSize={isSymbolPanelVisible ? (isTradePanelOpen ? 50 : 70) : 100}>
                  {modalOpen && <OneClick open={modalOpen} onClose={closeOneClickModal} />}
                  <TradingViewChart sx={{ position: 'relative' }} />
                </Panel>

                <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', width: "3px", transition: "background-color 0.2s ease", }} />
                {isSymbolPanelVisible && (<Panel id="symbol-panel" order={4} maxSize={50} minSize={25} defaultSize={isTradePanelOpen ? 25 : 30}>
                  <Box sx={{ height: "100%", width: "100%", padding: 0, margin: 0 }}>
                    <Box sx={{ height: "100%" }}>
                      <Box sx={{ width: "100%", p: 1, pb: 1, }}>
                        <SearchWithGroupFilter onSearchChange={handleSearch} setIsSearchDropdownOpen={setIsSearchDropdownOpen} />
                      </Box>

                      {isSearchDropdownOpen ? null : (
                        <WatchlistTable columns={visibleColumnsData} handleRowClick={handleRowClick} onRowDoubleClick={handleRowDoubleClick} activeRowId={activeRowId} data={hiddenSymbols.size > 0 ? sortedSymbols.filter(symbol => !hiddenSymbols.has(Number(symbol.id))) : sortedSymbols} onRowRightClick={handleRowRightClick} loading={loading} onHeaderClick={handleTableHeaderRightClick}></WatchlistTable>
                      )}
                      <Menu open={Boolean(menuPositionTH)} onClose={() => { setMenuPositionTH(null) }} anchorReference="anchorPosition" anchorPosition={menuPositionTH} sx={{ '& .MuiList-root': { padding: 0 } }} TransitionComponent={Grow}>
                        <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                          {symbolCellData.filter(col => !['name', 'bid', 'ask'].includes(col.dataIndex)) // Exclude name, bid, and ask columns
                            .map((col) => (
                              <MenuItem key={col.dataIndex} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", }} onClick={() => handleColumnVisibilityToggle(col.dataIndex)}>
                                {col.title}
                                {visibleColumns.includes(col.dataIndex) && <CheckIcon sx={{ fontSize: 18, color: "#4597ff", }} />}
                              </MenuItem>
                            ))}
                        </div>
                      </Menu>
                      <Menu open={Boolean(menuPosition)} onClose={() => { setMenuPosition(null) }} anchorReference="anchorPosition" anchorPosition={menuPosition} sx={{ "& .MuiList-root": { padding: 0 }, }} TransitionComponent={Grow}>
                        <MenuComponent onChartClick={handleChartClick} darkMode={darkMode} onOpenTradeModal={handleOpenOneTradeModal} closeMenu={handleCloseMenu} onHideSymbol={handleHideSymbol} handleOpenNewDashboard={() => handleOpenNewDashboard(selectedRow.name, selectedRow.id)} isTradePanelOpen={isTradePanelOpen} selectedRow={selectedRow} />
                      </Menu>
                      {/* handleOpenNewDashboard={handleOpenNewDashboard} */}
                    </Box>
                  </Box>
                </Panel>
                )}
              </PanelGroup>
            </Panel>
            <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', height: "3px" }} />
            <Panel id="bottom-panel" order={5} minSize={25} maxSize={50} defaultSize={30}>
              <div style={{ height: "100%", width: "100%" }}><TabPannel handleOpenOneTradeModal={handleOpenOneTradeModal} handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} /></div>
            </Panel>
          </PanelGroup>
        </Grid2>
      </LayoutWrapper>
    </>
  );
};

export default Dashboard;
